import { createAsyncLoadComponent } from '@/plugins/vue/createAsyncLoadComponent';


export default createAsyncLoadComponent(() => import('@/components/UploadManagerCard/index.vue'));
